import { useEffect, useState } from "react";
import { useOrkestaConfig } from "./use-orkesta-config";

export function useOrkestaPay() {
  const { data: orkestaConfig, isLoading: isLoadingOrkestaConfig } = useOrkestaConfig();
  const [deviceSessionId, setDeviceSessionId] = useState(null);
  const [orkestaPay, setOrkestaPay] = useState(null);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    let cancel = false;

    if (isLoadingOrkestaConfig || !orkestaConfig) return;

    async function init() {
      const config = {
        merchant_id: orkestaConfig.merchantId,
        public_key: orkestaConfig.publicKey,
        is_sandbox: orkestaConfig.sandbox,
      };
      try {
        const instance = window.initOrkestaPay(config);
        const data = await instance.getDeviceInfo();

        if (cancel) return;

        setDeviceSessionId(data.device_session_id);
        setOrkestaPay(instance);
        setIsLoaded(true);
      } catch (err) {
        if (cancel) return;
        console.error(err);
        setError(err);
      }
    }

    init();

    return () => {
      cancel = true;
    };
  }, [isLoadingOrkestaConfig, orkestaConfig]);

  const loading = !isLoaded && !error;

  return { deviceSessionId, orkestaPay, loading, error };
}